import request from '@/utils/request'

let Recruitment_submissionApi = {

  /*招聘投递列表*/
  list(data) {
    return request._post('/shop/plus.recruitment_submission.Index/index', data);
},
/*添加招聘投递*/
add(data) {
    return request._post('/shop/plus.recruitment_submission.Index/add', data);
},
/*修改招聘投递*/
edit(data) {
    return request._post('/shop/plus.recruitment_submission.Index/edit', data);
},
/*删除招聘投递*/
del(data) {
    return request._post('/shop/plus.recruitment_submission.Index/del', data);
},
/*招聘投递详情*/
detail(data) {
  return request._post('/shop/plus.recruitment_submission.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.recruitment_submission.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.recruitment_submission.Setting/getSetting', data, errorback);
    },
}
export default Recruitment_submissionApi;



// WEBPACK FOOTER //
// ./src/api/recruitment_submission.js